// Высота хэдера
export const HEADER_HEIGHT = 120;
